export const moreVertical = {
  name: "more-vertical" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.5 6.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-1.5 6.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["more-vertical"],
  category: "utility" as const,
};
